import React, { useState, useEffect } from 'react'
import { Modal, Button, Card } from 'react-bootstrap'
import { ArrowUp } from 'react-bootstrap-icons'
import { format } from 'date-fns'

const AdverseEventHistoryModal = (props) => {
  const { column, subColumn, objectHistory } = props
  const [ showModal, toggleShowModal ] = useState(false)
  const [ historyObjects, setHistoryObjects ] = useState([])

  const onCloseModal = () => {
    toggleShowModal(false)
  }

  useEffect(() => {
    let orderedObjectHistory = objectHistory ? [...objectHistory] : []
    orderedObjectHistory.reverse()


    let columnValue, modifiedDate, formattedObject
    let formattedObjects = []

    orderedObjectHistory.forEach((historyObject, index) => {
      if (index === 0) {
        columnValue = subColumn && historyObject[subColumn] ? historyObject[subColumn][column] : historyObject[column]
        modifiedDate = historyObject['modified_date']

        formattedObject = {
          value: columnValue,
          previousValue: null,
          date: format(new Date(modifiedDate), "PPpp"),
          type: "created"
        }
        formattedObjects.push(formattedObject)
      } else if(
          (!subColumn && (columnValue !== historyObject[column])) ||
          ((subColumn && historyObject[subColumn]) && (columnValue !== historyObject[subColumn][column]))
        ) {
        columnValue = subColumn ? historyObject[subColumn][column] : historyObject[column]
        modifiedDate = historyObject['modified_date']

        formattedObject = {
          value: columnValue,
          previousValue: formattedObject.value,
          date: format(new Date(modifiedDate), "PPpp"),
          type: "updated"
        }
        formattedObjects.push(formattedObject)
      }
    })
    setHistoryObjects(formattedObjects.reverse())
  }, [objectHistory, column, subColumn])
  return (
    <div>
      { historyObjects.length > 1 ?
        <>
          <Button onClick={ () => toggleShowModal(true) }>Show History</Button>
          <Modal show={ showModal } onHide={ onCloseModal }>
            <Modal.Header closeButton>
              <Modal.Title>
                History
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              { historyObjects.map((historyObject, index) => {
                let currentValue = historyObject.value
                let previousValue = historyObject.previousValue

                if (historyObject.value === null) {
                  currentValue = 'N/A'
                } else if (historyObject.value === false) {
                  currentValue = 'No'
                } else if (historyObject.value === true) {
                  currentValue = 'Yes'
                }

                if (historyObject.previousValue === null) {
                  previousValue = 'N/A'
                } else if (historyObject.previousValue === false) {
                  previousValue = 'No'
                } else if (historyObject.previousValue === true) {
                  previousValue = 'Yes'
                }

                return (
                    <div key={index}>
                    <Card>
                      <Card.Body>
                        { historyObject.type === "created" ?
                          <Card.Text>
                            <div>
                              <strong>Original Value</strong>: {currentValue}
                            </div>

                            <div>
                              Created on { historyObject.date }
                            </div>
                          </Card.Text>
                          :
                          <Card.Text>
                            <div>
                              <strong>Value</strong>: {currentValue}
                            </div>

                            <div>
                              <strong>Previous Value</strong>: {previousValue}
                            </div>

                            <div>
                              Modified on { historyObject.date }
                            </div>
                          </Card.Text>
                        }
                      </Card.Body>
                    </Card>

                    {index === historyObjects.length - 1 ?
                      null
                      :
                      <center>
                        <ArrowUp />
                      </center>
                    }
                  </div>
                )
              })
              }
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={ onCloseModal }>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </> 
        : 
        ""
      }
    </div>
  )
}

export default AdverseEventHistoryModal
